// 자동 생성된 시험 데이터
// 생성 시간: 2025-08-08 13:37:42
// 시험: architectural-engineer 2024년 2회

export const examSession = {
  "examInfo": {
    "title": "2024년 architectural-engineer 필기시험 2회",
    "subject": "architectural-engineer",
    "year": 2024,
    "session": 2,
    "totalQuestions": 100,
    "examDate": "2025-08-08",
    "generatedAt": "2025-08-08T13:37:42.302406",
    "imageBasePath": "/images/architectural-engineer/2024/session-2/"
  },
  "questions": [
    {
      "id": 1,
      "questionNumber": 1,
      "questionText": "쇼핑센터에서 고객의 주 보행동선으로서 중심 상점과 각 전문점에서의 출입이 이루어지는 곳은?",
      "options": [
        "몰(mall)",
        "코트(court)",
        "터미널(terminal)",
        "페데스트리언 지대(pedestrian area)"
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "몰(mall)은 쇼핑센터의 중심 보행통로로서, 고객들이 주로 이동하며 각 전문점으로의 접근이 이루어지는 공간입니다.",
      "tags": [
        "상업건축",
        "쇼핑센터",
        "동선계획"
      ],
      "hasImage": false
    },
    {
      "id": 2,
      "questionNumber": 2,
      "questionText": "메조넷형(maisonette type) 공동주택에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "주택내의 공간의 변화가 있다.",
        "거주성, 특히 프라이버시가 높다.",
        "소규모 단위평면에 적합한 유형이다.",
        "양면 개구에 의한 통풍 및 채광 확보가 양호하다."
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "메조넷형은 2층 구조의 복층형 주택으로 대규모 단위평면에 적합하며, 소규모 단위평면에는 부적합합니다.",
      "tags": [
        "공동주택",
        "메조넷",
        "주택유형"
      ],
      "hasImage": false
    },
    {
      "id": 3,
      "questionNumber": 3,
      "questionText": "전시실 순회방식에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "연속순회형식은 비교적 소규모 전시실에 적합하다.",
        "중앙홀형식은 홀의 크기가 크면 중앙부 동선의 혼란이 있다.",
        "갤러리 및 코리도형식은 복도 자체도 전시공간으로 이용이 가능하다.",
        "갤러리 및 코리도형식은 각 실에 직접 들어갈 수 있는 점이 유리하다."
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "중앙홀형식은 홀의 크기가 클수록 동선이 명확해지며, 작을 때 중앙부 동선의 혼란이 발생합니다.",
      "tags": [
        "전시건축",
        "동선계획",
        "전시실"
      ],
      "hasImage": false
    },
    {
      "id": 4,
      "questionNumber": 4,
      "questionText": "건축물과 양식의 연결이 옳지 않은 것은?",
      "options": [
        "노트르담 성당 - 고딕 양식",
        "샤르트르 성당 - 고딕 양식",
        "피사의 사탑 - 바로크 양식",
        "성 소피아 성당 - 비잔틴 양식"
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "피사의 사탑은 로마네스크 양식으로 건축된 건물이며, 바로크 양식이 아닙니다.",
      "tags": [
        "건축사",
        "건축양식",
        "서양건축"
      ],
      "hasImage": false
    },
    {
      "id": 5,
      "questionNumber": 5,
      "questionText": "래드번(Radburn) 계획에서 슈퍼블록을 구성함으로서 얻을 수 있는 효과로 옳지 않은 것은?",
      "options": [
        "충분한 공동의 오픈스페이스 확보 가능",
        "건축을 집약화함으로써 고층화·효율화 가능",
        "도로교통의 개선, 즉 보도와 차도의 완전한 분리 가능",
        "커뮤니티 시설의 중심배치로 간선도로변의 활성화 가능"
      ],
      "correctAnswer": 4,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "래드번 계획은 차도와 보도의 분리, 오픈스페이스 확보, 건축 집약화를 통한 효율성 증대가 목적이며, 간선도로변 활성화는 직접적인 효과가 아닙니다.",
      "tags": [
        "도시계획",
        "래드번",
        "슈퍼블록"
      ],
      "hasImage": false
    },
    {
      "id": 6,
      "questionNumber": 6,
      "questionText": "장애인 · 노인 · 임산부 등의 편의증진 보장에 관한 법령에 따른 편의시설 중 매개시설에 속하지 않는 것은?",
      "options": [
        "주출입구 접근로",
        "유도 및 안내설비",
        "장애인전용 주차구역",
        "주출입구 높이차이 제거"
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "유도 및 안내설비는 안내시설에 해당하며, 매개시설이 아닙니다. 매개시설은 건물 외부에서 내부로의 접근을 위한 시설입니다.",
      "tags": [
        "장애인편의시설",
        "법규",
        "매개시설"
      ],
      "hasImage": false
    },
    {
      "id": 7,
      "questionNumber": 7,
      "questionText": "주당 평균 40시간을 수업하는 어느 학교에서 음악실에서의 수업이 총 20시간이며 이 중 15시간은 음악시간으로 나머지 5시간은 학급 토론시간으로 사용되었다면, 이 음악실의 이용률과 순수율은?",
      "options": [
        "이용률 37.5%, 순수율 75%",
        "이용률 50%, 순수율 75%",
        "이용률 75%, 순수율 37.5%",
        "이용률 75%, 순수율 50%"
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "이용률 = 총 사용시간/전체시간 = 20/40 = 50%, 순수율 = 본래목적 사용시간/총 사용시간 = 15/20 = 75%",
      "tags": [
        "학교건축",
        "이용률",
        "순수율"
      ],
      "hasImage": false
    },
    {
      "id": 8,
      "questionNumber": 8,
      "questionText": "다음 중 사무소건축의 기둥간격 결정요소와 가장 거리가 먼 것은?",
      "options": [
        "책상배치의 단위",
        "주차배치의 단위",
        "엘리베이터의 설치 대수",
        "채광상 층높이에 의한 깊이"
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "사무소 건축의 기둥간격은 책상배치, 주차배치, 채광깊이 등 평면계획 요소에 의해 결정되며, 엘리베이터 설치 대수는 직접적인 관련이 적습니다.",
      "tags": [
        "사무소건축",
        "기둥간격",
        "평면계획"
      ],
      "hasImage": false
    },
    {
      "id": 9,
      "questionNumber": 9,
      "questionText": "공포를 기둥 위에만 배열한 것을 주심포형식이라고 한다. 다음 중 주심포형식의 건축물에 해당하는 것은?",
      "options": [
        "봉정사 극락전",
        "화암사 극락전",
        "봉정사 대웅전",
        "창경궁 명정전"
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "봉정사 극락전은 고려시대 건축물로 주심포형식의 대표적인 건축물입니다.",
      "tags": [
        "한국건축",
        "주심포",
        "전통건축"
      ],
      "hasImage": false
    },
    {
      "id": 10,
      "questionNumber": 10,
      "questionText": "건축공간의 치수는 인간을 기준으로 볼 때 3가지로 나누어서 생각할 수 있다. 다음 중 이 3가지 분류에 포함되지 않는 것은?",
      "options": [
        "환경적 스케일",
        "심리적 스케일",
        "생리적 스케일",
        "물리적 스케일"
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "건축공간의 치수는 생리적 스케일, 심리적 스케일, 물리적 스케일로 구분되며, 환경적 스케일은 이 분류에 포함되지 않습니다.",
      "tags": [
        "건축계획",
        "스케일",
        "공간"
      ],
      "hasImage": false
    },
    {
      "id": 11,
      "questionNumber": 11,
      "questionText": "고딕양식의 건축물에 속하지 않는 것은?",
      "options": [
        "아미앵 성당",
        "노트르담 성당",
        "샤르트르 성당",
        "성 베드로 성당"
      ],
      "correctAnswer": 4,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "성 베드로 성당은 르네상스와 바로크 양식이 혼재된 건축물로, 고딕양식이 아닙니다.",
      "tags": [
        "건축사",
        "고딕양식",
        "서양건축"
      ],
      "hasImage": false
    },
    {
      "id": 12,
      "questionNumber": 12,
      "questionText": "다음 설명에 알맞은 공장건축의 레이아웃(layout) 형식은?",
      "options": [
        "혼성식 레이아웃",
        "고정식 레이아웃",
        "제품중심의 레이아웃",
        "공정중심의 레이아웃"
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "제품중심의 레이아웃은 제품의 생산 흐름에 따라 설비와 작업장을 배치하는 방식입니다.",
      "tags": [
        "공장건축",
        "레이아웃",
        "생산시설"
      ],
      "hasImage": false
    },
    {
      "id": 13,
      "questionNumber": 13,
      "questionText": "주택법상 주택단지의 복리시설에 속하지 않는 것은?",
      "options": [
        "경로당",
        "관리사무소",
        "어린이놀이터",
        "주민운동시설"
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "관리사무소는 복리시설이 아닌 관리시설에 해당합니다.",
      "tags": [
        "주택법",
        "복리시설",
        "주택단지"
      ],
      "hasImage": false
    },
    {
      "id": 14,
      "questionNumber": 14,
      "questionText": "다음의 호텔 중 연면적에 대한 숙박면적의 비가 일반적으로 가장 큰 것은?",
      "options": [
        "커머셜 호텔",
        "클럽 하우스",
        "리조트 호텔",
        "아파트먼트 호텔"
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "커머셜 호텔은 비즈니스 목적의 호텔로 숙박시설이 차지하는 비율이 가장 높습니다.",
      "tags": [
        "숙박시설",
        "호텔",
        "면적비율"
      ],
      "hasImage": false
    },
    {
      "id": 15,
      "questionNumber": 15,
      "questionText": "다음 설명에 알맞은 도서관의 자료 출납시스템 유형은?\n 이용자가 직접 서고내의 서가에서 도서자료의 제목 정도는 볼 수 있지만 내용을 열람하고자 할 경우 관원에게 대출을 요구해야 하는 형식",
      "options": [
        "폐가식",
        "반개가식",
        "자유개가식",
        "안전개가식"
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "반개가식은 이용자가 서가에서 도서를 확인할 수 있지만 직접 대출은 불가능한 시스템입니다.",
      "tags": [
        "도서관",
        "출납시스템",
        "반개가식"
      ],
      "hasImage": false
    },
    {
      "id": 16,
      "questionNumber": 16,
      "questionText": "상점의 판매방식에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "측면판매방식은 직원 동선의 이동성이 많다.",
        "대면판매방식은 측면판매방식에 비해 상품 진열 면적이 넓어진다.",
        "측면판매방식은 고객이 직접 진열된 상품을 접촉할 수 있는 관계로 선택이 용이하다.",
        "대면판매방식은 쇼케이스를 중심으로 판매원이 고정된 자리나 위치를 확보하는 것이 용이하다."
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "대면판매방식은 쇼케이스 중심으로 이루어져 상품 진열면적이 측면판매방식보다 좁습니다.",
      "tags": [
        "상업건축",
        "판매방식",
        "상점계획"
      ],
      "hasImage": false
    },
    {
      "id": 17,
      "questionNumber": 17,
      "questionText": "주택의 부엌계획에 관한 설명 중 옳지 않은 것은?",
      "options": [
        "일사가 긴 서쪽은 음식물이 부패하기 쉬우므로 피하도록 한다.",
        "부엌은 가사노동의 경감을 위해 작업삼각형의 각 변의 합은 10m 이내로 한다.",
        "부엌의 평면형 중 일렬형은 동선과 배치가 간단한 평면형이지만 설비기구가 많은 경우에는 작업동선이 길어진다.",
        "부엌의 평면형 중 ㄱ자형은 식사실과 함께 이용할 경우에 적합하다."
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "부엌의 작업삼각형 각 변의 합은 6m 이내로 하는 것이 적당하며, 10m는 너무 깁니다.",
      "tags": [
        "주택계획",
        "부엌",
        "작업삼각형"
      ],
      "hasImage": false
    },
    {
      "id": 18,
      "questionNumber": 18,
      "questionText": "다음 중 구조코어로서 가장 바람직한 코어형식으로 바닥면적이 큰 고층, 초고층사무소에 적합한 것은?",
      "options": [
        "중심코어형",
        "편심코어형",
        "독립코어형",
        "양단코어형"
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "바닥면적이 큰 고층, 초고층 사무소에서는 중심코어형이 효율적인 평면 활용과 구조적 안정성을 제공합니다.",
      "tags": [
        "사무소건축",
        "코어",
        "고층건축"
      ],
      "hasImage": false
    },
    {
      "id": 19,
      "questionNumber": 19,
      "questionText": "다음은 객석의 가시거리에 관한 설명이다. ( )안에 알맞은 것은?\n 연극 등을 감상하는 경우 연기자의 표정을 읽을 수 있는 가시한계는 ( ㉠ ) 정도이다. 그러나 실제적으로 극장에서는 잘 보여야 하는 동시에 많은 관객을 수용해야 하므로 ( ㉡ )까지를 제1차 허용한도로 한다.",
      "options": [
        "㉠ 10m, ㉡ 22m",
        "㉠ 15m, ㉡ 22m",
        "㉠ 10m, ㉡ 25m",
        "㉠ 15m, ㉡ 25m"
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "연기자 표정 식별 가시한계는 15m, 실용적 허용한도는 22m입니다.",
      "tags": [
        "극장",
        "가시거리",
        "관람시설"
      ],
      "hasImage": false
    },
    {
      "id": 20,
      "questionNumber": 20,
      "questionText": "병원건축의 병동배치에서 분관식(pavilion type)이 집중식(block type)보다 좋은 점은?",
      "options": [
        "각종 설비시설의 배관길이가 짧아진다.",
        "각 병실의 일조와 통풍이 유리하다.",
        "비교적 작은 대지에도 건축할 수 있다.",
        "이용자들의 동선이 짧아진다."
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "분관식은 건물들이 분산 배치되어 각 병실의 일조와 통풍이 집중식보다 유리합니다.",
      "tags": [
        "병원건축",
        "분관식",
        "병동배치"
      ],
      "hasImage": false
    },
    {
      "id": 21,
      "questionNumber": 21,
      "questionText": "콘크리트의 크리프에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "습도가 높을수록 크리프는 크다.",
        "물-시멘트비가 클수록 크리프는 크다.",
        "콘크리트의 배합과 골재의 종류는 크리프에 영향을 끼친다.",
        "하중이 제거되면 크리프 변형은 일부 회복된다."
      ],
      "correctAnswer": 1,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "습도가 낮을수록 크리프가 크며, 습도가 높으면 크리프는 작아집니다.",
      "tags": [
        "콘크리트",
        "크리프",
        "재료특성"
      ],
      "hasImage": false
    },
    {
      "id": 22,
      "questionNumber": 22,
      "questionText": "건설사업지원 통합 전산망으로 건설 생산활동 전 과정에서 건설 관련 주체가 전산망을 통해 신속히 교환 · 공유할 수 있도록 자원하는 통합 정보시스템을 지칭하는 용어는?",
      "options": [
        "건설 CIC(Computer Intergrated Construction)",
        "건설 CALS(Continuous Acquisition&Life Cycle Support)",
        "건설 EC(Engineering Construction)",
        "건설 EVMS(Earned Value Meanagement System)"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "건설 CALS는 건설 생산활동 전 과정의 정보를 통합 관리하는 시스템입니다.",
      "tags": [
        "건설정보화",
        "CALS",
        "전산망"
      ],
      "hasImage": false
    },
    {
      "id": 23,
      "questionNumber": 23,
      "questionText": "다음 중 공사감리업무와 가장 거리가 먼 항목은?",
      "options": [
        "설계도서의 적정성 검토",
        "공사 실행예산의 편성",
        "시공상의 안전관리지도",
        "사용자재와 설계도서와의 일치여부 검토"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "공사 실행예산의 편성은 시공자의 업무이며, 감리업무가 아닙니다.",
      "tags": [
        "건설관리",
        "감리",
        "공사관리"
      ],
      "hasImage": false
    },
    {
      "id": 24,
      "questionNumber": 24,
      "questionText": "주문받은 건설업자가 대상계획의 기업, 금융, 토지조달, 설계, 시공 기타 모든 요소를 포괄하여 발주하는 도급계약방식은?",
      "options": [
        "실비청산 보수가산 도급",
        "정액도급",
        "공동도급",
        "턴키도급"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "턴키도급은 설계부터 시공까지 모든 과정을 일괄 수행하는 계약방식입니다.",
      "tags": [
        "계약",
        "턴키",
        "도급방식"
      ],
      "hasImage": false
    },
    {
      "id": 25,
      "questionNumber": 25,
      "questionText": "건축공사 시 직접공사비 구성 항목으로 옳게 짝지어진 것은?",
      "options": [
        "재료비, 노무비, 장비비, 간접공사비",
        "재료비, 노무비, 외주비, 간접공사비",
        "재료비, 노무비, 일반관리비, 경비",
        "재료비, 노무비, 외주비, 경비"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "직접공사비는 재료비, 노무비, 외주비, 경비로 구성됩니다.",
      "tags": [
        "공사비",
        "직접공사비",
        "견적"
      ],
      "hasImage": false
    },
    {
      "id": 26,
      "questionNumber": 26,
      "questionText": "철근의 정착 위치에 관한 설명 중 옳지 않은 것은?",
      "options": [
        "지중보 철근은 기초 또는 기둥에 정착한다.",
        "기둥 철근은 큰 보 혹은 작은 보에 정착한다.",
        "직교하는 단부 보 밑에 기둥이 없을 때에는 벽체에 정착한다.",
        "벽철근은 기둥, 보, 기초 또는 바닥판에 정착한다."
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "기둥 철근은 기초, 보, 또는 바닥판에 정착하며, 큰 보나 작은 보의 구분은 정착위치 결정요소가 아닙니다.",
      "tags": [
        "철근공사",
        "정착",
        "철근배근"
      ],
      "hasImage": false
    },
    {
      "id": 27,
      "questionNumber": 27,
      "questionText": "문 윗틀과 문짝에 설치하여 문이 자동적으로 닫혀지게 하며, 개폐압력을 조절할 수 있는 장치는?",
      "options": [
        "도어 체크(Door check)",
        "도어 홀더(Door holder)",
        "피봇 힌지(Pivot hinge)",
        "도어 체인(Door chain)"
      ],
      "correctAnswer": 1,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "도어 체크는 문이 자동으로 닫히도록 하고 개폐압력을 조절할 수 있는 장치입니다.",
      "tags": [
        "건축금물",
        "도어체크",
        "문시설"
      ],
      "hasImage": false
    },
    {
      "id": 28,
      "questionNumber": 28,
      "questionText": "지하연속벽(Slury wall)에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "차수성이 우수하다.",
        "비교적 지반조건에 좌우되지 않는다.",
        "소음·진동이 적고, 벽체의 강성이 높다.",
        "공사비가 타공법에 비하여 저렴하고 공기가 단축된다."
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "지하연속벽은 공사비가 타공법에 비해 비싸고 공기가 오래 걸리는 단점이 있습니다.",
      "tags": [
        "기초공사",
        "지하연속벽",
        "토공사"
      ],
      "hasImage": false
    },
    {
      "id": 29,
      "questionNumber": 29,
      "questionText": "건설현장에서 굳지 않은 콘크리트에 대해 실시하는 시험으로 옳지 않은 것은?",
      "options": [
        "슬럼프(Slump) 시험",
        "코어(Core) 시험",
        "염화물 시험",
        "공기량 시험"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "코어 시험은 경화된 콘크리트에 실시하는 시험이며, 굳지 않은 콘크리트 시험이 아닙니다.",
      "tags": [
        "콘크리트",
        "품질관리",
        "시험"
      ],
      "hasImage": false
    },
    {
      "id": 30,
      "questionNumber": 30,
      "questionText": "타일의 크기가 200mm × 200mm이고, 가로 세로 줄눈의 크기는 10mm인 타일로 벽면적 100m²가 되는 벽체를 시공하는 경우의 타일 매수로 적당한 것은 어느 것인가? (단, 정미량이며 깨짐에 의한 손실은 없는 것으로 한다.)",
      "options": [
        "2368매",
        "2268매",
        "2468매",
        "2678매"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "타일+줄눈 크기 = 210mm × 210mm = 0.0441m², 100m² ÷ 0.0441m² ≈ 2268매",
      "tags": [
        "타일공사",
        "수량산출",
        "마감공사"
      ],
      "hasImage": false
    },
    {
      "id": 31,
      "questionNumber": 31,
      "questionText": "사운딩(Sounding)이란 저항체를 땅속에 삽입하여서 관입, 회전, 인발 등의 저항으로 토층의 성상을 탐사하는 방법이다. 다음 중 사운딩(Sounging) 시험에 속하지 않는 시험법은?",
      "options": [
        "표준관입시험",
        "콘 관입시험",
        "베인전단시험",
        "말뚝의 재하시험"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "말뚝의 재하시험은 말뚝의 지지력을 측정하는 시험으로 사운딩 시험이 아닙니다.",
      "tags": [
        "지반조사",
        "사운딩",
        "토질시험"
      ],
      "hasImage": false
    },
    {
      "id": 32,
      "questionNumber": 32,
      "questionText": "지반조사의 시험에 관계되는 것을 연결한 것 중 옳은 것은?",
      "options": [
        "진흙의 점착력 - 베인시험(Vane Test)",
        "지내력 - 정량분석시험",
        "연한점토 - 표준관입시험",
        "염분 - 씬 월 샘플링(Thin Wall Sampling)"
      ],
      "correctAnswer": 1,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "베인시험은 진흙의 점착력을 측정하는 현장시험입니다.",
      "tags": [
        "지반조사",
        "베인시험",
        "점착력"
      ],
      "hasImage": false
    },
    {
      "id": 33,
      "questionNumber": 33,
      "questionText": "압연강재가 냉각될 때 표면에 생기는 산화철 표피를 무엇이라 하는가?",
      "options": [
        "스패터",
        "밀스케일",
        "슬래그",
        "비드"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "밀스케일은 압연강재 냉각 시 표면에 생기는 산화철 표피입니다.",
      "tags": [
        "강재",
        "밀스케일",
        "재료"
      ],
      "hasImage": false
    },
    {
      "id": 34,
      "questionNumber": 34,
      "questionText": "콘크리트를 타설하면서 거푸집을 수직 방향으로 이동시켜 연속작업을 할 수 있게 한 것으로 사일로 등의 건설공사에 적합한 것은?",
      "options": [
        "Euro form",
        "Sliding form",
        "Air tube form",
        "Traveling form"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "슬라이딩 폼은 거푸집을 수직으로 이동시키며 연속 타설하는 공법으로 사일로 등에 적합합니다.",
      "tags": [
        "거푸집",
        "슬라이딩폼",
        "콘크리트공사"
      ],
      "hasImage": false
    },
    {
      "id": 35,
      "questionNumber": 35,
      "questionText": "다음은 공법에 관한 내용이다. 맞는 내용은?\n \"미리 공장 생산한 기둥이나 보, 바닥판, 외벽, 내벽 등을 한층씩 쌓아 올라가는 조립식으로 구체를 구축하고 이어서 마감 및 설비공사까지 포함하여 차례로 한층씩 완성해 가는 공법\"",
      "options": [
        "하프 PC합성바닥판공법",
        "역타공법",
        "적층공법",
        "지하연속벽공법"
      ],
      "correctAnswer": 3,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "적층공법은 미리 제작된 부재를 층별로 조립하여 완성해가는 공법입니다.",
      "tags": [
        "시공법",
        "적층공법",
        "PC공법"
      ],
      "hasImage": false
    },
    {
      "id": 36,
      "questionNumber": 36,
      "questionText": "연강철선을 전기용접하여 정방형 또는 장방형으로 만든 것으로 콘크리트 다짐바닥, 지면 콘크리트 포장 등에 사용하는 금속재는?",
      "options": [
        "와이어 라스(Wire lath)",
        "와이어 메쉬(Wire mesh)",
        "메탈 라스(Metal lath)",
        "익스팬디드 메탈(Expended Metal)"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "와이어 메쉬는 연강철선을 용접하여 격자형으로 만든 보강재로 콘크리트 포장에 사용됩니다.",
      "tags": [
        "보강재",
        "와이어메쉬",
        "콘크리트보강"
      ],
      "hasImage": false
    },
    {
      "id": 37,
      "questionNumber": 37,
      "questionText": "석고 플라스터 바름에 대한 설명으로 옳지 않은 것은?",
      "options": [
        "보드용 플라스터는 초벌바름, 재벌바름의 경우 물을 가한 후 2시간 이상 경화한 것은 사용할 수 없다.",
        "실내온도가 10℃ 이하일 때는 공사를 중단한다.",
        "바름 작업 중에는 될 수 있는 한 통풍을 방지한다.",
        "바름 작업이 끝난 후 실내를 밀폐하지 않고 가열과 동시에 환기하여 바름면이 서서히 건조되도록 한다."
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "석고 플라스터 시공 시 실내온도는 5℃ 이하일 때 공사를 중단하며, 10℃는 적정 시공온도입니다.",
      "tags": [
        "마감공사",
        "석고플라스터",
        "좌관공사"
      ],
      "hasImage": false
    },
    {
      "id": 38,
      "questionNumber": 38,
      "questionText": "PERT-CPM 공정표 작성 시에 EST와 EFT의 계산방법 중 옳지 않은 것은?",
      "options": [
        "작업의 흐름에 따라 전진 계산한다.",
        "개시결합점에서 나간 작업의 EST=0 으로 한다.",
        "어느 작업의 EFT는 그 작업의 EST에 소요일수를 가하여 구한다.",
        "복수의 작업에 종속되는 작업의 EST는 선행작업 중 EFT의 최소값으로 한다."
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "복수의 작업에 종속되는 작업의 EST는 선행작업 중 EFT의 최대값으로 합니다.",
      "tags": [
        "공정관리",
        "PERT-CPM",
        "일정계획"
      ],
      "hasImage": false
    },
    {
      "id": 39,
      "questionNumber": 39,
      "questionText": "시멘트 분말도 시험방법이 아닌 것은?",
      "options": [
        "플로우시험법",
        "체분석법",
        "피크노메타법",
        "브레인법"
      ],
      "correctAnswer": 1,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "플로우시험법은 시멘트의 유동성을 측정하는 시험으로 분말도 시험이 아닙니다.",
      "tags": [
        "시멘트",
        "품질시험",
        "분말도"
      ],
      "hasImage": false
    },
    {
      "id": 40,
      "questionNumber": 40,
      "questionText": "다음 중 언더피닝(Under Pinning) 공법의 종류가 아닌 것은?",
      "options": [
        "갱·피어 공법",
        "잭파일(Jacked pile) 공법",
        "그라우트 주입공법",
        "콘크리트 VH 타설법"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "콘크리트 VH 타설법은 언더피닝 공법이 아닙니다.",
      "tags": [
        "기초공사",
        "언더피닝",
        "보강공법"
      ],
      "hasImage": false
    },
    {
      "id": 41,
      "questionNumber": 41,
      "questionText": "지름 20mm, 길이 200mm인 철근에 인장력을 가했을 때, 지름이 0.0052mm 감소하였고, 길이는 0.17mm 늘어났다. 이 재료의 푸아송비는?",
      "options": [
        "3.26923",
        "0.00085",
        "0.00026",
        "0.30588"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "푸아송비 = 횡변형률/종변형률 = (0.0052/20)/(0.17/200) = 0.00026/0.00085 ≈ 0.30588",
      "tags": [
        "재료역학",
        "푸아송비",
        "변형"
      ],
      "hasImage": false
    },
    {
      "id": 42,
      "questionNumber": 42,
      "questionText": "토질 및 지반에 관한 설명 중 옳지 않은 것은?",
      "options": [
        "자갈층·모래층은 투수성이 큰 편이지만 젖은 점토층은 투수성이 작다.",
        "점토와 모래의 중간 크기를 갖는 흙을 실트라 한다.",
        "지진 시 액상화 현상은 모래질 지반보다 점토질 지반에서 일어나기 쉽다.",
        "점토질 지반에서 흙의 내부마찰각이 같은 경우 점착력이 클수록 옹벽에 가해지는 토압은 작아진다."
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "액상화 현상은 점토질 지반보다 모래질 지반에서 더 쉽게 발생합니다.",
      "tags": [
        "토질역학",
        "액상화",
        "지반"
      ],
      "hasImage": false
    },
    {
      "id": 43,
      "questionNumber": 43,
      "questionText": "그림과 같은 정정구조의 CD부재에서 C, D점의 휨모멘트값 중 옳은 것은?",
      "options": [
        "(C) 0kN·m, (D) 16kN·m",
        "(C) 16kN·m, (D) 16kN·m",
        "(C) 0kN·m, (D) 32kN·m",
        "(C) 32kN·m, (D) 32kN·m"
      ],
      "correctAnswer": 1,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "정정구조에서 C점은 힌지이므로 휨모멘트가 0이고, D점에서는 하중에 의한 휨모멘트가 발생합니다.",
      "tags": [
        "구조역학",
        "휨모멘트",
        "정정구조"
      ],
      "hasImage": true,
      "image": {
        "src": "page_01_image_066.png",
        "description": "문제 43 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-2/page_01_image_066.png"
    },
    {
      "id": 44,
      "questionNumber": 44,
      "questionText": "강도설계법에서 철근콘크리트 부재 중 콘크리트의 공칭전단강도(Vc)가 40kN, 전단철근에 의한 공칭전단강도(Vs)가 20kN일 때, 이 부재의 설계전단강도(φVn)는? (단, 강도감소계수는 0.75 적용)",
      "options": [
        "60kN",
        "58kN",
        "52kN",
        "45kN"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "φVn = φ(Vc + Vs) = 0.75 × (40 + 20) = 45kN",
      "tags": [
        "철근콘크리트",
        "전단강도",
        "강도설계법"
      ],
      "hasImage": false
    },
    {
      "id": 45,
      "questionNumber": 45,
      "questionText": "철근콘크리트 T형보의 유효폭 산정식에 관련된 사항과 거리가 먼 것은?",
      "options": [
        "보의 폭",
        "슬래브 중심간 거리",
        "슬래브의 두께",
        "보의 춤"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "T형보의 유효폭은 보의 폭, 슬래브 중심간 거리, 슬래브 두께와 관련되며, 보의 춤은 직접적 관련이 적습니다.",
      "tags": [
        "철근콘크리트",
        "T형보",
        "유효폭"
      ],
      "hasImage": false
    },
    {
      "id": 46,
      "questionNumber": 46,
      "questionText": "지진의 진도(Intensity)와 규모(Magnitude)에 대한 설명으로 옳지 않은 것은?",
      "options": [
        "진도는 상대적 개념의 지진크기이다.",
        "규모는 장소에 관계없는 절대적 개념의 크기이다.",
        "진도는 사람이 느끼는 감각, 물체이동 등을 계급별로 구분한다.",
        "규모는 지반의 운동정도를 평가하나 정밀하지는 않다."
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "규모는 지반의 운동정도를 정밀하게 평가하는 지표입니다.",
      "tags": [
        "지진",
        "진도",
        "규모"
      ],
      "hasImage": false
    },
    {
      "id": 47,
      "questionNumber": 47,
      "questionText": "철골구조 주각부의 구성요소가 아닌 것은?",
      "options": [
        "커버 플레이트",
        "앵커볼트",
        "베이스 모르타르",
        "베이스 플레이트"
      ],
      "correctAnswer": 1,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "커버 플레이트는 철골구조 주각부의 구성요소가 아닙니다.",
      "tags": [
        "철골구조",
        "주각부",
        "구성요소"
      ],
      "hasImage": false
    },
    {
      "id": 48,
      "questionNumber": 48,
      "questionText": "그림과 같은 단순보의 C점의 휨모멘트는?",
      "options": [
        "\\frac{1}{8}wL^2",
        "\\frac{3}{8}wL^2",
        "\\frac{5}{8}wL^2",
        "\\frac{7}{16}wL^2"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "등분포하중을 받는 단순보에서 중앙점의 최대 휨모멘트는 $\\frac{3}{8}wL^2$입니다.",
      "tags": [
        "구조역학",
        "휨모멘트",
        "단순보"
      ],
      "hasImage": true,
      "image": {
        "src": "page_01_image_067.png",
        "description": "문제 48 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-2/page_01_image_067.png"
    },
    {
      "id": 49,
      "questionNumber": 49,
      "questionText": "그림과 같은 H형강 단면의 핵면적을 구하면?",
      "options": [
        "932.47mm²",
        "1,864.93mm²",
        "2,797.40mm²",
        "3,745.81mm²"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "H형강의 핵면적은 주어진 치수를 이용하여 계산하며, 결과는 3,745.81mm²입니다.",
      "tags": [
        "강구조",
        "H형강",
        "핵면적"
      ],
      "hasImage": true,
      "image": {
        "src": "page_01_image_068.png",
        "description": "문제 49 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-2/page_01_image_068.png"
    },
    {
      "id": 50,
      "questionNumber": 50,
      "questionText": "강구조에서 용접선 단부에 붙인 보조판으로 아크의 시작이나 종단부의 크레이터 등의 결함을 방지하기 위해 붙이는 판은?",
      "options": [
        "스티프너",
        "엔드탭",
        "윙플레이트",
        "커버플레이트"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "엔드탭은 용접 시작과 종료 부분의 결함을 방지하기 위한 보조판입니다.",
      "tags": [
        "강구조",
        "용접",
        "엔드탭"
      ],
      "hasImage": false
    },
    {
      "id": 51,
      "questionNumber": 51,
      "questionText": "다음 조건을 가진 압축재의 좌굴하중 P값으로 옳은 것은?\n E=1.39×10⁵ N·mm², K=1, L=400cm, \n부재 단면 400×400mm",
      "options": [
        "3,123·8kN",
        "4,517·8kN",
        "5,012·8kN",
        "5,713·8kN"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "오일러 좌굴하중 공식을 사용하여 계산하면 약 5,713·8kN입니다.",
      "tags": [
        "구조역학",
        "좌굴",
        "압축재"
      ],
      "hasImage": false
    },
    {
      "id": 52,
      "questionNumber": 52,
      "questionText": "인장을 받는 이형철근의 직경이 D16(직경 15.9mm)이고, 콘크리트 강도가 30MPa인 표준갈고리의 기본정착길이는? (단, fy=400MPa, β=1.0, ms=2,300kg/m³)",
      "options": [
        "238mm",
        "258mm",
        "279mm",
        "312mm"
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "표준갈고리의 기본정착길이 계산 결과 279mm입니다.",
      "tags": [
        "철근콘크리트",
        "정착길이",
        "갈고리"
      ],
      "hasImage": false
    },
    {
      "id": 53,
      "questionNumber": 53,
      "questionText": "한계상태설계법에 따라 강구조물을 설계할 때 고려되는 강도한계상태가 아닌 것은?",
      "options": [
        "기둥의 좌굴",
        "접합부 파괴",
        "바닥재의 진동",
        "피로 파괴"
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "바닥재의 진동은 사용한계상태에 해당하며, 강도한계상태가 아닙니다.",
      "tags": [
        "강구조",
        "한계상태설계",
        "강도한계상태"
      ],
      "hasImage": false
    },
    {
      "id": 54,
      "questionNumber": 54,
      "questionText": "그림과 같은 양단고정보에서 A단의 휨모멘트는? (단, 등분포하중 w=3kN/m, L=3m)",
      "options": [
        "2.8kN·m",
        "1kN·m",
        "1.4kN·m",
        "2kN·m"
      ],
      "correctAnswer": 1,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "양단고정보에서 지점 모멘트는 wL²/12로 계산되며, 2.8kN·m입니다.",
      "tags": [
        "구조역학",
        "고정보",
        "휨모멘트"
      ],
      "hasImage": true,
      "image": {
        "src": "page_01_image_070.png",
        "description": "문제 54 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-2/page_01_image_070.png"
    },
    {
      "id": 55,
      "questionNumber": 55,
      "questionText": "그림과 같은 H형강(440×300×10×20) 단면의 전소성모멘트(Mp)는 얼마인가? (단, fy=400MPa)",
      "options": [
        "963kN·m",
        "1,168kN·m",
        "1,363kN·m",
        "1,568kN·m"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "H형강의 전소성모멘트 계산 결과 1,168kN·m입니다.",
      "tags": [
        "강구조",
        "전소성모멘트",
        "H형강"
      ],
      "hasImage": true,
      "image": {
        "src": "page_01_image_071.png",
        "description": "문제 55 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-2/page_01_image_071.png"
    },
    {
      "id": 56,
      "questionNumber": 56,
      "questionText": "강도설계법에서 균형보의 개념을 옳게 설명한 것은?",
      "options": [
        "콘크리트와 철근의 응력이 각각 허용응력에 도달한 보를 말한다.",
        "사용하중 상태에서 파괴형태를 고려하지 않은 보를 말한다.",
        "경제적인 단면설계를 위주로 한 보를 말한다.",
        "철근이 항복함과 동시에 콘크리트의 압축변형률이 0.0033에 도달한 보를 말한다."
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "균형보는 철근 항복과 콘크리트 압축변형률 한계가 동시에 발생하는 보입니다.",
      "tags": [
        "철근콘크리트",
        "균형보",
        "강도설계법"
      ],
      "hasImage": false
    },
    {
      "id": 57,
      "questionNumber": 57,
      "questionText": "필릿치수 8mm, 용접길이 500mm인 양면필릿용접의 유효단면적은 약 얼마인가?",
      "options": [
        "2,100mm²",
        "3,221mm²",
        "4,300mm²",
        "5,421mm²"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "양면필릿용접의 유효단면적 = 2 × 0.707 × 8 × 500 ≈ 5,421mm²",
      "tags": [
        "강구조",
        "용접",
        "필릿용접"
      ],
      "hasImage": false
    },
    {
      "id": 58,
      "questionNumber": 58,
      "questionText": "다음 캔틸레버보의 자유단의 처짐각은? (단, 탄성계수 E, 단면2차모멘트 I)",
      "options": [
        "\\frac{PL^2}{2EI}",
        "\\frac{PL^3}{3EI}",
        "\\frac{PL^2}{6EI}",
        "\\frac{PL^3}{8EI}"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "캔틸레버보 자유단의 처짐각은 $\\frac{PL^3}{8EI}$입니다.",
      "tags": [
        "구조역학",
        "처짐각",
        "캔틸레버"
      ],
      "hasImage": true,
      "image": {
        "src": "page_01_image_072.png",
        "description": "문제 58 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-2/page_01_image_072.png"
    },
    {
      "id": 59,
      "questionNumber": 59,
      "questionText": "그림과 같은 구조물의 부정정 차수는?",
      "options": [
        "불안정",
        "1차 부정정",
        "2차 부정정",
        "3차 부정정"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "구조물의 부정정 차수를 계산하면 3차 부정정입니다.",
      "tags": [
        "구조역학",
        "부정정",
        "구조해석"
      ],
      "hasImage": true,
      "image": {
        "src": "page_01_image_073.png",
        "description": "문제 59 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-2/page_01_image_073.png"
    },
    {
      "id": 60,
      "questionNumber": 60,
      "questionText": "강도설계법에서 처짐을 계산하지 않는 경우, 철근 콘크리트 보의 최소두께 규정으로 옳지 않은 것은? (단, 보통콘크리트와 설계기준항복강도 400MPa 철근을 사용한 부재임)",
      "options": [
        "단순지지 : l/16",
        "1단연속 : l/18.5",
        "양단연속 : l/12",
        "캔틸레버 : l/8"
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "양단연속보의 최소두께는 l/21이며, l/12는 틀렸습니다.",
      "tags": [
        "철근콘크리트",
        "최소두께",
        "처짐"
      ],
      "hasImage": false
    },
    {
      "id": 61,
      "questionNumber": 61,
      "questionText": "조명기구를 사용하는 도중에 광원의 능률저하나 기구의 오염, 손상 등으로 조도가 점차 저하되는데, 인공 조명 설계 시 이를 고려하여 반영하는 계수는?",
      "options": [
        "광도",
        "조명률",
        "실지수",
        "감광 보상률"
      ],
      "correctAnswer": 4,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "감광 보상률은 시간에 따른 조도 저하를 고려한 계수입니다.",
      "tags": [
        "조명",
        "감광보상률",
        "조도설계"
      ],
      "hasImage": false
    },
    {
      "id": 62,
      "questionNumber": 62,
      "questionText": "실내공기오염의 종합적 지표로서 사용되는 오염 물질은?",
      "options": [
        "부유분진",
        "이산화탄소",
        "일산화탄소",
        "이산화질소"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "이산화탄소는 실내공기오염의 종합적 지표로 사용됩니다.",
      "tags": [
        "공기조화",
        "실내공기질",
        "이산화탄소"
      ],
      "hasImage": false
    },
    {
      "id": 63,
      "questionNumber": 63,
      "questionText": "다음의 냉방부하 발생요인 중 현열부하만 발생시키는 것은?",
      "options": [
        "인체의 발생열량",
        "벽체로부터의 취득열량",
        "극간풍에 의한 취득열량",
        "외기의 도입으로 인한 취득열량"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "벽체로부터의 취득열량은 현열부하만 발생시킵니다.",
      "tags": [
        "공기조화",
        "냉방부하",
        "현열부하"
      ],
      "hasImage": false
    },
    {
      "id": 64,
      "questionNumber": 64,
      "questionText": "통기관의 설치 목적으로 옳지 않은 것은?",
      "options": [
        "트랩의 봉수를 보호한다.",
        "오수와 잡배수가 서로 혼합되지 않게 한다.",
        "배수계통 내의 배수 및 공기의 흐름을 원활히 한다.",
        "배수관 내에 환기를 도모하여 관 내를 청결하게 유지한다."
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "통기관은 오수와 잡배수의 혼합 방지가 목적이 아닙니다.",
      "tags": [
        "급배수",
        "통기관",
        "배수시설"
      ],
      "hasImage": false
    },
    {
      "id": 65,
      "questionNumber": 65,
      "questionText": "전압이 1[V]일 때 1[A]의 전류가 1[s] 동안 하는 일을 나타내는 것은?",
      "options": [
        "1[Ω]",
        "1[J]",
        "1[dB]",
        "1[W]"
      ],
      "correctAnswer": 4,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "1V×1A×1s = 1W(와트)입니다.",
      "tags": [
        "전기설비",
        "전력",
        "와트"
      ],
      "hasImage": false
    },
    {
      "id": 66,
      "questionNumber": 66,
      "questionText": "다음과 같은 특징을 갖는 배선 방법은?\n- 열적영향이나 기계적 외상을 받기 쉬운 곳이 아니면 금속관 배선과 같이 광범위하게 사용 가능하다. \n- 관자체가 절연체이므로 감전의 우려가 없으며 시공이 용이하다.",
      "options": [
        "금속덕트 배선",
        "버스덕트 배선",
        "플로어덕트 배선",
        "합성수지관 배선"
      ],
      "correctAnswer": 4,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "합성수지관 배선은 절연체이므로 감전 우려가 없고 시공이 용이합니다.",
      "tags": [
        "전기설비",
        "배선",
        "합성수지관"
      ],
      "hasImage": false
    },
    {
      "id": 67,
      "questionNumber": 67,
      "questionText": "압력탱크 급수방식에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "정전시 급수가 곤란하다.",
        "급수 압력을 일정하게 유지할 수 있다.",
        "단수 시 저수조의 물을 사용할 수 있다.",
        "탱크를 높은 곳에 설치하지 않아도 된다."
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "압력탱크 급수방식은 급수 압력을 완전히 일정하게 유지하기 어렵습니다.",
      "tags": [
        "급배수",
        "압력탱크",
        "급수방식"
      ],
      "hasImage": false
    },
    {
      "id": 68,
      "questionNumber": 68,
      "questionText": "어떤 상태의 습공기를 절대습도의 변화없이 건구온도만 상승시킬 때, 습공기의 상태변화로 옳은 것은?",
      "options": [
        "엔탈피는 증가한다.",
        "비체적은 감소한다.",
        "노점온도는 낮아진다.",
        "상대습도는 증가한다."
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "절대습도가 일정하고 건구온도가 상승하면 엔탈피는 증가합니다.",
      "tags": [
        "공기조화",
        "습공기",
        "엔탈피"
      ],
      "hasImage": false
    },
    {
      "id": 69,
      "questionNumber": 69,
      "questionText": "간접가열식 급탕방식에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "저압보일러를 써도 되는 경우가 많다.",
        "직접가열식에 비해 소규모 급탕설비에 적합하다.",
        "급탕용 보일러는 난방용 보일러와 겸용할 수 있다.",
        "직접가열식에 비해 보일러 내면의 스케일이 발생할 염려가 적다."
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "간접가열식은 대규모 급탕설비에 적합하며, 소규모에는 직접가열식이 적합합니다.",
      "tags": [
        "급탕설비",
        "간접가열식",
        "급탕방식"
      ],
      "hasImage": false
    },
    {
      "id": 70,
      "questionNumber": 70,
      "questionText": "압력에 따른 도시가스의 분류에서 고압의 기준으로 옳은 것은?(단, 게이지압력 기준)",
      "options": [
        "0.1MPa 이상",
        "1MPa 이상",
        "10MPa 이상",
        "100MPa 이상"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "도시가스의 고압 기준은 게이지압력 1MPa 이상입니다.",
      "tags": [
        "가스설비",
        "도시가스",
        "압력분류"
      ],
      "hasImage": false
    },
    {
      "id": 71,
      "questionNumber": 71,
      "questionText": "다음과 같은 조건에서 실의 현열부하가 7,000W인 경우 실내 취출풍량은? \n[조건] \n• 실내온도 : 22℃ \n• 취출공기온도 : 12℃ \n• 공기의 비열 : 1.01 kJ/kg·K \n• 공기의 밀도 : 1.2 kg/m³",
      "options": [
        "1,042 m³/h",
        "2,079 m³/h",
        "3,472 m³/h",
        "6,944 m³/h"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "Q = ρ×V×Cp×ΔT에서 V = Q/(ρ×Cp×ΔT) = 7000/(1.2×1.01×1000×10) ≈ 2,079 m³/h",
      "tags": [
        "공기조화",
        "풍량계산",
        "현열부하"
      ],
      "hasImage": false
    },
    {
      "id": 72,
      "questionNumber": 72,
      "questionText": "엘리베이터의 조작 방식 중 무운전원 방식으로 다음과 같은 특징을 갖는 것은? \n승객 스스로 운전하는 전자동 엘리베이터로, 승강장으로부터의 호출 신호로 기동, 정지를 이루는 조작 방식이며, 누른 순서에 상관없이 각 호출에 응하여 자동적으로 정지한다.",
      "options": [
        "단식자동방식",
        "카 스위치방식",
        "승합전자동방식",
        "시그널 콘트롤 방식"
      ],
      "correctAnswer": 3,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "승합전자동방식은 승객이 직접 조작하는 무운전원 방식입니다.",
      "tags": [
        "수직교통",
        "엘리베이터",
        "조작방식"
      ],
      "hasImage": false
    },
    {
      "id": 73,
      "questionNumber": 73,
      "questionText": "다음 중 트랩의 봉수 파괴 원인이 아닌 것은?",
      "options": [
        "자기 사이펀 작용",
        "유도 사이펀 작용",
        "증발현상",
        "자정작용"
      ],
      "correctAnswer": 4,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "자정작용은 트랩의 봉수 파괴 원인이 아닙니다.",
      "tags": [
        "급배수",
        "트랩",
        "봉수파괴"
      ],
      "hasImage": false
    },
    {
      "id": 74,
      "questionNumber": 74,
      "questionText": "다음 중 건축물 실내공간의 잔향시간에 가장 큰 영향을 주는 것은?",
      "options": [
        "실의 용적",
        "음원의 위치",
        "벽체의 두께",
        "음원의 음압"
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "잔향시간은 실의 용적에 가장 큰 영향을 받습니다.",
      "tags": [
        "음향설비",
        "잔향시간",
        "실내음향"
      ],
      "hasImage": false
    },
    {
      "id": 75,
      "questionNumber": 75,
      "questionText": "양수 펌프의 회전수를 원래보다 20% 증가시켰을 경우 양수량의 변화로 옳은 것은?",
      "options": [
        "20% 증가",
        "44% 증가",
        "73% 증가",
        "100% 증가"
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "펌프 법칙에 의해 회전수가 20% 증가하면 양수량도 20% 증가합니다.",
      "tags": [
        "급배수",
        "펌프",
        "양수량"
      ],
      "hasImage": false
    },
    {
      "id": 76,
      "questionNumber": 76,
      "questionText": "다음과 같은 공식을 통해 산출되는 값으로 전기설비가 어느 정도 유효하게 사용되는가를 나타내는 것은?",
      "options": [
        "부하율",
        "보상률",
        "부등률",
        "수용률"
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "부하율은 평균전력을 최대전력으로 나눈 비율입니다.",
      "tags": [
        "전기설비",
        "부하율",
        "전력관리"
      ],
      "hasImage": true,
      "image": {
        "src": "page_01_image_074.png",
        "description": "문제 76 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-2/page_01_image_074.png"
    },
    {
      "id": 77,
      "questionNumber": 77,
      "questionText": "다음의 간선 배전방식 중 분전반에서 사고가 발생했을 때 그 파급 범위가 가장 좁은 것은?",
      "options": [
        "평행식",
        "방사선식",
        "나뭇가지식",
        "나뭇가지 평행식"
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "평행식은 각 회로가 독립적이어서 사고 파급범위가 가장 좁습니다.",
      "tags": [
        "전기설비",
        "배전방식",
        "평행식"
      ],
      "hasImage": false
    },
    {
      "id": 78,
      "questionNumber": 78,
      "questionText": "연결송수관설비의 방수구에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "방수구의 위치표시는 표시등 또는 축광식 표지로 한다.",
        "호스접결구는 바닥으로부터 0.5m 이상 1m 이하의 위치에 설치한다.",
        "개폐기능을 가진 것으로 설치하여야 하며, 평상 시 닫힌 상태를 유지하도록 한다.",
        "연결송수관설비의 전용방수구 또는 옥내소화전 방수구로서 구경 50mm의 것으로 설치한다."
      ],
      "correctAnswer": 4,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "연결송수관설비의 방수구는 구경 65mm로 설치합니다.",
      "tags": [
        "소방설비",
        "연결송수관",
        "방수구"
      ],
      "hasImage": false
    },
    {
      "id": 79,
      "questionNumber": 79,
      "questionText": "900명을 수용하고 있는 극장에서 실내 CO₂ 농도를 0.1%로 유지하기 위해 필요한 환기량은? (단, 외기의 CO₂ 농도는 0.04%, 1인당 CO₂ 배출량은 18L/h 이다.)",
      "options": [
        "27,000m³/h",
        "30,000m³/h",
        "60,000m³/h",
        "66,000m³/h"
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "환기량 = (900×18)/(0.1-0.04) = 16,200/0.06 = 27,000m³/h",
      "tags": [
        "공기조화",
        "환기",
        "CO₂농도"
      ],
      "hasImage": false
    },
    {
      "id": 80,
      "questionNumber": 80,
      "questionText": "덕트의 분기부에 설치하여 풍량조절용으로 사용되는 댐퍼는?",
      "options": [
        "스플릿 댐퍼",
        "평행익형 댐퍼",
        "대향익형 댐퍼",
        "버터플라이 댐퍼"
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "스플릿 댐퍼는 덕트 분기부에서 풍량조절용으로 사용됩니다.",
      "tags": [
        "공기조화",
        "댐퍼",
        "풍량조절"
      ],
      "hasImage": false
    },
    {
      "id": 81,
      "questionNumber": 81,
      "questionText": "건축법령상 건축물의 대지에 공개공지 또는 공개공간을 확보하여야 하는 대상 건축물에 속하지 않는 것은? (단, 해당 용도로 쓰는 바닥면적의 합계가 5,000m²인 건축물의 경우)",
      "options": [
        "종교시설",
        "의료시설",
        "업무시설",
        "숙박시설"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "의료시설은 공개공지 확보 대상 건축물에 포함되지 않습니다.",
      "tags": [
        "건축법",
        "공개공지",
        "대상건축물"
      ],
      "hasImage": false
    },
    {
      "id": 82,
      "questionNumber": 82,
      "questionText": "지구단위계획 중 관계 행정기관의 장과의 협의, 국토교통부장관과의 협의 및 중앙도시계획위원회 · 지방도시계획위원회 또는 공동위원회의 심의를 거치지 않고 변경할 수 있는 사항에 관한 기준 내용으로 옳은 것은?",
      "options": [
        "건축선의 2m 이내의 변경인 경우",
        "획지면적의 30% 이내의 변경인 경우",
        "가구면적의 20% 이내의 변경인 경우",
        "건축물 높이의 30% 이내의 변경인 경우"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "지구단위계획의 경미한 변경 기준 중 하나는 획지면적의 30% 이내 변경입니다.",
      "tags": [
        "도시계획",
        "지구단위계획",
        "경미변경"
      ],
      "hasImage": false
    },
    {
      "id": 83,
      "questionNumber": 83,
      "questionText": "다음은 건축선에 따른 건축제한에 관한 기준 내용이다. ( ) 안에 알맞은 것은? \n도로면으로부터 높이 ( ) 이하에 있는 출입구, 창문, 그 밖에 이와 유사한 구조물은 열고 닫을 때 건축선의 수직면을 넘지 아니하는 구조로 하여야 한다.",
      "options": [
        "1.5m",
        "2.5m",
        "3.5m",
        "4.5m"
      ],
      "correctAnswer": 4,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "건축선에 따른 건축제한에서 높이 4.5m 이하의 출입구, 창문 등이 대상입니다.",
      "tags": [
        "건축법",
        "건축선",
        "건축제한"
      ],
      "hasImage": false
    },
    {
      "id": 84,
      "questionNumber": 84,
      "questionText": "건축물로부터 바깥쪽으로 나가는 출구를 국토교통부령으로 정하는 기준에 따라 설치하여야 하는 대상 건축물에 속하지 않는 것은?",
      "options": [
        "종교시설",
        "의료시설 중 종합병원",
        "교육연구시설 중 학교",
        "문화 및 집회시설 중 관람장"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "의료시설 중 종합병원은 피난시설 설치 대상에서 제외됩니다.",
      "tags": [
        "건축법",
        "피난시설",
        "출구설치"
      ],
      "hasImage": false
    },
    {
      "id": 85,
      "questionNumber": 85,
      "questionText": "건축물의 거실에 국토교통부령으로 정하는 기준에 따라 배연설비를 하여야 하는 대상 건축물에 속하지 않는 것은? (단, 피난층의 거실은 제외하며, 6층 이상인 건축물의 경우)",
      "options": [
        "종교시설",
        "판매시설",
        "위락시설",
        "방송통신시설"
      ],
      "correctAnswer": 4,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "방송통신시설은 배연설비 설치 대상에 포함되지 않습니다.",
      "tags": [
        "건축법",
        "배연설비",
        "대상건축물"
      ],
      "hasImage": false
    },
    {
      "id": 86,
      "questionNumber": 86,
      "questionText": "건축물 관련 건축기준의 허용오차 범위 기준이 2% 이내가 아닌 것은?",
      "options": [
        "출구너비",
        "반자높이",
        "평면길이",
        "벽체두께"
      ],
      "correctAnswer": 4,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "벽체두께의 허용오차는 2% 이내가 아닌 다른 기준을 적용합니다.",
      "tags": [
        "건축법",
        "허용오차",
        "건축기준"
      ],
      "hasImage": false
    },
    {
      "id": 87,
      "questionNumber": 87,
      "questionText": "다음 중 제2종 일반주거지역 안에서 건축할 수 없는 건축물은? (단, 도시·군계획 조례가 정하는 바에 따라 건축할 수 있는 경우는 고려하지 않는다.)",
      "options": [
        "종교시설",
        "운수시설",
        "노유자시설",
        "제1종 근린생활시설"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "운수시설은 제2종 일반주거지역에서 건축할 수 없습니다.",
      "tags": [
        "도시계획",
        "용도지역",
        "건축제한"
      ],
      "hasImage": false
    },
    {
      "id": 88,
      "questionNumber": 88,
      "questionText": "공동주택과 오피스텔의 난방설비를 개별난방 방식으로 하는 경우의 기준으로 틀린 것은?",
      "options": [
        "보일러실의 윗부분에는 그 면적이 0.5m² 이상인 환기창을 설치할 것",
        "보일러는 거실 외의 곳에 설치하되, 보일러를 설치하는 곳과 거실사이의 경계벽은 출입구를 제외하고는 내화구조의 벽으로 구획할 것",
        "보일러의 연도는 방화구조로서 개별연도로 설치할 것",
        "기름보일러를 설치하는 경우 기름 저장소를 보일러실 외의 다른 곳에 설치할 것"
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "보일러의 연도는 내화구조로 설치하며, 방화구조가 아닙니다.",
      "tags": [
        "건축법",
        "개별난방",
        "보일러설치"
      ],
      "hasImage": false
    },
    {
      "id": 89,
      "questionNumber": 89,
      "questionText": "건축물의 층수 산정에 관한 기준이 틀린 것은?",
      "options": [
        "지하층은 건축물의 층수에 산입하지 아니한다.",
        "층의 구분이 명확하지 아니한 건축물은 그 건축물의 높이 4m 마다 하나의 층으로 보고 그 층수를 산정한다.",
        "건축물이 부분에 따라 그 층수가 다른 경우에는 바닥면적에 따라 가중평균한 층수를 그 건축물의 층수로 본다.",
        "계단탑으로서 그 수평투영면적의 합계가 해당 건축물 건축면적의 8분의 1 이하인 것은 건축물의 층수에 산입하지 아니한다."
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "건축물이 부분에 따라 층수가 다른 경우 최고층수를 기준으로 하며, 가중평균하지 않습니다.",
      "tags": [
        "건축법",
        "층수산정",
        "건축기준"
      ],
      "hasImage": false
    },
    {
      "id": 90,
      "questionNumber": 90,
      "questionText": "다음 중 내화구조에 속하지 않는 것은?",
      "options": [
        "철근콘크리트조 기둥의 경우 그 작은 지름이 20cm인 것",
        "철근콘크리트조 바닥의 경우 두께가 10cm인 것",
        "철근콘크리트조로 된 보",
        "철근콘크리토조로 된 지붕"
      ],
      "correctAnswer": 1,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "철근콘크리트조 기둥의 내화구조 기준은 지름 25cm 이상이므로 20cm는 해당하지 않습니다.",
      "tags": [
        "건축법",
        "내화구조",
        "구조기준"
      ],
      "hasImage": false
    },
    {
      "id": 91,
      "questionNumber": 91,
      "questionText": "계단의 설치 기준으로 옳은 것은?",
      "options": [
        "계단을 대체하여 설치하는 경사로는 그 경사로가 1 : 8을 넘어야 하며, 표면을 거친 면으로 미끄러지지 아니하는 재료로 마감하여야 한다.",
        "모든 공동주택의 주계단, 피난계단 또는 특별피난계단에 설치하는 난간 및 바닥은 아동의 이용에 안전하고 노약자 및 신체장애인의 이용에 편리한 구조로 하여야 한다.",
        "업무시설의 주계단, 피난계단 또는 특별피난계단에 설치하는 난간 손잡이는 벽 등으로부터 5cm 이상 떨어지도록 하고, 계단으로부터의 높이는 85cm가 되도록 한다.",
        "돌음계단의 단너비는 그 넓은 너비의 끝부분으로부터 30cm의 위치에서 측정한다."
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "업무시설의 계단 난간 손잡이는 벽으로부터 5cm 이상 떨어지고 높이 85cm로 설치합니다.",
      "tags": [
        "건축법",
        "계단설치",
        "피난시설"
      ],
      "hasImage": false
    },
    {
      "id": 92,
      "questionNumber": 92,
      "questionText": "출입구의 개소에 관계없이 노외주차장의 차로의 너비를 최소 6m 이상으로 하여야 하는 주차형식은? (단, 이륜자동차전용 외의 노외주차장의 경우)",
      "options": [
        "평행주차",
        "직각주차",
        "교차주차",
        "45도 대향주차"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "직각주차는 차로 너비를 최소 6m 이상으로 하여야 합니다.",
      "tags": [
        "건축법",
        "주차장",
        "차로너비"
      ],
      "hasImage": false
    },
    {
      "id": 93,
      "questionNumber": 93,
      "questionText": "건축허가신청에 필요한 설계도서 중 건축계획서에 표시하여야 할 사항으로 옳지 않은 것은?",
      "options": [
        "주차장규모",
        "토지형질변경계획",
        "건축물의 용도별 면적",
        "지역 · 지구 및 도시계획사항"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "토지형질변경계획은 건축계획서에 표시할 사항이 아닙니다.",
      "tags": [
        "건축법",
        "건축허가",
        "설계도서"
      ],
      "hasImage": false
    },
    {
      "id": 94,
      "questionNumber": 94,
      "questionText": "국토의 계획 및 이용에 관한 법령에 따른 기반시설 중 공간시설에 속하지 않는 것은?",
      "options": [
        "녹지",
        "유원지",
        "유수지",
        "공공공지"
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "유수지는 공간시설이 아닌 방재시설에 해당합니다.",
      "tags": [
        "도시계획",
        "기반시설",
        "공간시설"
      ],
      "hasImage": false
    },
    {
      "id": 95,
      "questionNumber": 95,
      "questionText": "관련 규정에 의하여 건축물에 설치하는 지하층의 구조 및 설비에 관한 기준 내용으로 옳지 않은 것은?",
      "options": [
        "거실의 바닥면적이 50m² 이상인 층에는 직통계단 외에 피난층 또는 지상으로 통하는 비상탈출구 및 환기통을 설치할 것",
        "바닥면적이 1,000m² 이상인 층에는 피난층 또는 지상으로 통하는 직통계단을 방화구획으로 구획되는 각 부분마다 1개소 이상 설치하되, 이를 피난계단 및 특별피난계단의 구조로 할 것",
        "거실의 바닥면적의 합계가 1,000m² 이상인 층에는 환기설비를 설치할 것",
        "지하층의 바닥면적이 200m² 이상인 층에는 식수 공급을 위한 급수전을 1개소 이상 설치할 것"
      ],
      "correctAnswer": 4,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "지하층 급수전 설치 기준은 바닥면적 200m² 이상이 아닌 다른 기준을 적용합니다.",
      "tags": [
        "건축법",
        "지하층",
        "피난시설"
      ],
      "hasImage": false
    },
    {
      "id": 96,
      "questionNumber": 96,
      "questionText": "높이 31m를 넘는 각 층의 바닥면적 중 최대 바닥면적이 4,500m²인 종합병원에 설치하여야 할 비상용 승강기 최소대수는?",
      "options": [
        "1대",
        "2대",
        "3대",
        "4대"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "높이 31m 초과 건축물에서 최대 바닥면적 4,500m²인 경우 비상용 승강기 2대를 설치해야 합니다.",
      "tags": [
        "건축법",
        "비상용승강기",
        "승강기설치"
      ],
      "hasImage": false
    },
    {
      "id": 97,
      "questionNumber": 97,
      "questionText": "건축법령상 용어의 정의가 옳지 않은 것은?",
      "options": [
        "초고층 건축물이란 층수가 50층 이상이거나 높이가 200m 이상인 건축물을 말한다.",
        "증축이란 기존 건축물이 있는 대지에서 건축물의 건축면적, 연면적, 층수 또는 높이를 늘리는 것을 말한다.",
        "개축이란 건축물이 천재지변이나 그 밖의 재해로 멸실된 경우 그 대지에 종전과 같은 규모의 범위에서 다시 축조하는 것을 말한다.",
        "부속건축물이란 같은 대지에서 주된 건축물과 분리된 부속용도의 건축물로서 주된 건축물을 이용 또는 관리하는 데에 필요한 건축물을 말한다."
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "개축은 기존 건축물을 철거하고 새로 건축하는 것으로, 멸실된 경우의 재축조는 복구에 해당합니다.",
      "tags": [
        "건축법",
        "용어정의",
        "개축"
      ],
      "hasImage": false
    },
    {
      "id": 98,
      "questionNumber": 98,
      "questionText": "건축지도원에 관한 내용으로 틀린 것은?",
      "options": [
        "건축지도원은 특별자치시 · 특별자치도 또는 시 · 군 · 구에 근무하는 건축직렬의 공무원과 건축에 관한 학식이 풍부한 자 중에서 지정한다.",
        "건축지도원의 자격과 업무 범위는 건축조례로 정한다.",
        "건축설비가 법령 등에 적합하게 유지·관리되고 있는지 확인 · 지도 및 단속한다.",
        "허가를 받지 아니하거나 신고를 하지 아니하고 건축하거나 용도 변경한 건축물을 단속한다."
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "건축지도원의 자격과 업무범위는 국토교통부령으로 정하며, 건축조례가 아닙니다.",
      "tags": [
        "건축법",
        "건축지도원",
        "지도감독"
      ],
      "hasImage": false
    },
    {
      "id": 99,
      "questionNumber": 99,
      "questionText": "건축물이 있는 대지의 분할 제한 조건과 관련이 없는 규정은?",
      "options": [
        "대지와 도로의 관계",
        "건축물의 피난시설·용도제한규정",
        "대지안의 공지",
        "일조 등의 확보를 위한 건축물의 높이제한"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "건축물의 피난시설·용도제한규정은 대지분할 제한 조건과 직접적 관련이 없습니다.",
      "tags": [
        "건축법",
        "대지분할",
        "제한조건"
      ],
      "hasImage": false
    },
    {
      "id": 100,
      "questionNumber": 100,
      "questionText": "지하식 또는 건축물식 노외주차장의 차로에 관한 기준 내용으로 옳지 않은 것은? (단, 이륜자동차 전용 노외주차장이 아닌 경우)",
      "options": [
        "높이는 주차바닥면으로부터 2.3m 이상으로 하여야 한다.",
        "경사로의 종단경사도는 직선부분에서는 17%를 초과하여서는 아니된다.",
        "곡선부분은 자동차가 4m 이상의 내변반경으로 회전할 수 있도록 하여야 한다.",
        "주차대수 규모가 50대 이상인 경우의 경사로는 너비 6m 이상인 2차로를 확보하거나 진입차로와 진출차로를 분리하여야 한다."
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "지하주차장 곡선부분의 내변반경은 6m 이상이어야 하며, 4m는 틀렸습니다.",
      "tags": [
        "건축법",
        "주차장",
        "차로기준"
      ],
      "hasImage": false
    }
  ]
};

// 시험 기본 정보
export const getExamInfo = () => examSession.examInfo;

// 문제 목록
export const getQuestions = () => examSession.questions;

// 특정 문제 조회
export const getQuestion = (questionNumber) => {
  return examSession.questions.find(q => q.questionNumber === questionNumber);
};

// 이미지 URL 생성
export const getImageUrl = (imageName) => {
  return examSession.examInfo.imageBasePath + imageName;
};

export default examSession;
